import React, { useState } from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import TopSection from './topSection';
import { Marginer } from '../../components/marginer';

import { AboutUs } from './aboutUs';
import { TopCars } from './topCars';
import { Footer } from '../../components/footer';
import { CategoryFilter } from '../../components/categoryFilter';
import { getSiteConfig } from '../../constants/siteConfig';
import { useSnapshot } from 'valtio';
import { Role, roleStore } from '../../../store/roleStore';
import { useBrandRules } from '../../hooks/useHostCapabilities';
import { CarCardPriceMode, homePriceTabs } from '../../utils/carCardPrice';

const PageContainer = styled.div`
  ${tw`w-full max-w-full min-w-0 h-full flex flex-col overflow-x-hidden items-stretch box-border pb-8 md:pb-16`}
`;

export default function HomePage() {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const siteConfig = getSiteConfig();
  const showCategoryFilter = !siteConfig.allowedProductTypes;
  const { role } = useSnapshot(roleStore);
  const isGuest = role === Role.GUEST;
  // Spec 022 D13: the price mode and the car type are two choices. Until the guest picks a tab,
  // the brand's card price is selected (D10).
  const { carCardPrice: brandPriceMode } = useBrandRules();
  const [pickedPriceMode, setPickedPriceMode] = useState<CarCardPriceMode | null>(null);
  const priceMode = isGuest ? (pickedPriceMode ?? brandPriceMode) : 'daily';

  return (
    <PageContainer>
      <TopSection />
      <Marginer direction="vertical" margin="0.3em" />
      {showCategoryFilter && (
        <CategoryFilter
          selectedCategory={selectedCategory}
          onCategoryChange={setSelectedCategory}
          priceTabs={isGuest ? homePriceTabs(brandPriceMode) : []}
          priceMode={priceMode}
          onPriceModeChange={setPickedPriceMode}
        />
      )}
      <Marginer direction="vertical" margin="1.5em" />
      <TopCars
        selectedCategory={showCategoryFilter ? selectedCategory : 'all'}
        priceMode={priceMode}
        brandPriceMode={brandPriceMode}
      />
      <Marginer margin={10} />
    </PageContainer>
  );
}
